<template>
  <component :is="componentTag" />
</template>
<script>
import webTechnicalStandard from './web';
import mobileTechnicalStandard from './mobile';
export default {
  components: {
    webTechnicalStandard,
    mobileTechnicalStandard
  },
  data() {
    return {
       isMobile: false,
       componentTag: ''
    };
  },
  created() {
     this.listenObserverWidth(750);
  },
  methods: {
    // 监听可视窗口宽度
    listenObserverWidth(mobileWidth) {
       const resizeObserver = new ResizeObserver(entries => {
          for(let entry of entries) {
             if(entry.contentRect.width <= mobileWidth) {
                this.componentTag = 'mobileTechnicalStandard';
             } else {
                this.componentTag = 'webTechnicalStandard';
             }
          }
       });
       resizeObserver.observe(document.body);
    }
  },
};
</script>